export default "./dist/stdassets/images/icons/pan.png";